















































import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { BankModule, NavModule, ProfileModule } from "@/store";
import { MediaQuery } from '@/MediaQuery';
import { RouterUtils } from '@/router/RouterUtils'

// Define the props by using Vue's canonical way.
const FutureFundsProps = Vue.extend({
  props: {
    'authUserId': {
      type: String,
      default: 'UNSET'
    },
    'hideButtons': {
      type: Boolean,
      default: false
    }
  },
  mixins: [RouterUtils]
});

@Component({
  components: {}
})
export default class FutureFunds extends FutureFundsProps {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  // Define a new component called button-counter
  MediaQuery = MediaQuery;
  
  scheduledAllocations: any[] = []
  
  // return which card is active
  get activeItem () {
      return this.$store.state.bank.activeItem
  }
  get scheduledAllocationsBalance () {
      let bal = 0.0
      for (var i in this.scheduledAllocations) {
        var allocation = this.scheduledAllocations[i]
        if (allocation.status === 'pending') {
          bal = bal + allocation.amount
        }
        if (allocation.status === 'reversed') {
          bal = bal - allocation.amount
        }
      }
      return bal
  }
  // return whether to show the buttons or not
  get showButtons () {
    if (
        this.hideButtons === true ||
        (this.hideButtons as unknown as string) === '' ||
        (this.hideButtons as unknown as string) === 'true'
      ) {
        return false
      }
      return true
  }
  
  mounted () {
    // get scheduled allocations for user
    this.scheduledAllocations = this.bankStore.scheduledAllocations.filter(item => {
      return item.authUserId === this.authUserId
    })
  }
}
